import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./Testimonials.css";  

const Testimonials = () => {
  const testimonials = [
    {
      text: `MeHome turned my dream home into reality! The team’s attention to detail and commitment to excellence 
      made the entire process stress-free. Every corner reflects elegance and comfort.`,
      author: "Hari Krishna",
      role: "Homeowner, Hyderabad",
      image: "images/author-1.jpg",
    },
    {
      text: `Working with MeHome was an incredible experience. Their designers understood our vision instantly 
      and transformed our space with style, warmth, and perfection.`,
      author: " Imran",
      role: "CEO – DesignCore",
      image: "images/author-1.jpg",
    },
  ];

  return (
    <section className="mehome-testimonials">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Image */}
          <div className="col-lg-6">
            <div className="testimonial-image wow fadeInLeft">
              <img src="imgs/clients.jpg" alt="Client Testimonials" />
            </div>
          </div>

          {/* Right Content */}
          <div className="col-lg-6">
            <div className="testimonial-content">
              <div className="section-title">
                <h5 className="subtitle">Client Testimonials</h5>
                <h2 className="title text-anime-style-2">
                  Trusted by hundreds of <span>Happy Clients</span> of{" "}
                  <span>MeHome</span>.
                </h2>
                <p className="description">
                  We take pride in designing spaces that inspire and last a lifetime.
                  Here’s what our clients say about their MeHome experience.
                </p>
              </div>

              <Swiper
                modules={[Autoplay, Pagination]}
                autoplay={{
                  delay: 4000,
                  disableOnInteraction: false,
                }}
                pagination={{ clickable: true }}
                loop={true}
                slidesPerView={1}
                className="testimonial-slider"
              >
                {testimonials.map((item, i) => (
                  <SwiperSlide key={i}>
                    <div className="testimonial-card wow fadeInUp">
                      <div className="testimonial-stars">
                        {[...Array(5)].map((_, idx) => (
                          <i key={idx} className="fa-solid fa-star"></i>
                        ))}
                      </div>

                      <p className="testimonial-text">“{item.text}”</p>

                      <div className="testimonial-author">
                        <img src={item.image} alt={item.author} />
                        <div>
                          <h4>{item.author}</h4>
                          <p>{item.role}</p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>

              <div className="testimonial-rating-summary">
                <h2>4.9</h2>
                <div className="stars">
                  {[...Array(5)].map((_, idx) => (
                    <i key={idx} className="fa-solid fa-star"></i>
                  ))}
                </div>
                <p>Based on 2,488 reviews from our MeHome clients</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
